import { render } from "./DocumentClassAttributesSubView.vue?vue&type=template&id=7675b166&scoped=true&ts=true"
import script from "./DocumentClassAttributesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassAttributesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassAttributesSubView.vue?vue&type=style&index=0&id=7675b166&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7675b166"]])

export default __exports__